module.exports = __webpack_public_path__ + "img/yyy.07328e12.png";